module.exports = __webpack_public_path__ + "static/media/PM140.b5d6d9e6.png";